/**
 * Витяг qr_token з відсканованого QR (Sprint B).
 *
 * Бейдж працівника кодує ПОВНИЙ URL виду `…/sewing/login/qr/<token>`, а не
 * сирий токен. Якщо слати весь URL у /login/qr чи /attendance/checkin — бек
 * не знаходить швею (find_by_qr_token(url)=None → 401). Тому нормалізуємо:
 * дістаємо токен з URL, або приймаємо вже «голий» токен як є.
 *
 * Підтримувані форми:
 *   https://host/sewing/login/qr/ABC123        → ABC123
 *   https://host/sewing/login/qr/ABC123?x=1     → ABC123
 *   https://host/scan?t=ABC123 / ?token=ABC123  → ABC123
 *   ABC123                                       → ABC123 (як є)
 */
export function extractQrToken(raw: string): string {
  const s = (raw || "").trim();
  if (!s) return "";

  const marker = "/sewing/login/qr/";
  if (s.includes(marker)) {
    return s.split(marker)[1].split(/[?#]/)[0].replace(/\/+$/, "");
  }

  // Спроба як URL із ?t= / ?token=
  try {
    const u = new URL(s);
    const t = u.searchParams.get("t") || u.searchParams.get("token");
    if (t) return t.trim();
    // URL без відомого параметра — беремо останній сегмент шляху
    const seg = u.pathname.replace(/\/+$/, "").split("/").pop();
    if (seg) return seg;
  } catch {
    /* не URL — повертаємо як є нижче */
  }
  return s;
}
